import css from 'styled-jsx/css';

export default css.global`/* global */

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mb-4 {
  margin-bottom: 1.25rem;
}

.pr-2 {
  padding-right: 2rem;
}

.font-normal {
  font-weight: normal !important;
}

.font-bold {
  font-weight: bold;
}

/* Row card flex */

.row-card-flex {
  display: flex;
  flex-flow: wrap;
}

/* .jumbotron {
  height: 650px; */
/* background-color: #21714b; */
/* background-image: url("/static/img/home-hero.jpg");
  background-size: cover;
  padding: 0;
  display: flex;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
} */
.small{
  font-size: 12px;
}

.main-content .top h2 {
  padding: 2em 3em;
  color: #666666;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.7em;
}

.main-content {
  margin-bottom: 40px;
}

.intro-head-text {
  padding: 3em;
}

.mini-bar.jumbotron {
  padding: 0 !important;
  height: 20px !important;
}

.affiliate.jumbotron {
  height: 400px;
  text-align: center;
  padding: 0;
  display: flex;
  align-items: center;
}

.affiliate.jumbotron h2 {
  font-size: 20px;
  line-height: 1.5em;
}

.hero {
  /* color: #fff; */
}

.hero h2 {
  font-size: 25px;
  font-weight: 500;
}

.hero h1 {
  font-size: 45px;
  font-weight: 800;
}

.hero p img {
  width: 8%;
}

.hero p {
  font-weight: 600;
}

#btn-addon2 {
  background-color: #0c4596;
  color: #fff;
  font-weight: 300;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-color: rgb(42, 94, 167);
  cursor: pointer;
}

.hero input {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

.products h2 {
  color: #bc1824 !important;
}

.products-container {
  display: flex;
  margin-bottom: 13px;
  flex-wrap: wrap;
}

.product {
  display: flex;
  width: 77%;
  align-items: center;
}

.suite-container .product {
  margin-bottom: 15px;
}

.hero .product,
.product.new {
  width: 100%;
  align-items: center;
  height: 60px;
  justify-content: center;
}

.product-card {
  /* height: 150px; */
  background: #fff;
  margin: 10px;
  color: #4e4d4d;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 20px rgba(161, 160, 160, 0.3);
  border-radius: 10px;
  padding: 10px;
}
.product-card-new-look {
  border: 1px solid #E7E6E6;
  border-radius: 24px;
}

/* .enterprise-card {
  height:fit-content;
  background: #fff;
  margin: 10px;
  color: #4e4d4d;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 20px rgba(161, 160, 160, 0.3);
  border-radius: 10px;
  padding: 10px;
}

.enterprise-card p:first-child{
  font-weight: 700;
  font-size: 18px;
} */
/* .grey-text{
  color: #9F9F9F;
  font-size: 12px;
  padding-top: 4px;
} */

.product-card .product-descr,
.product-card .product {
  padding: 5px 20px;
}

.product-descr {
  font-size: 12px;
}

.product-descr.new {
  font-size: 9px;
  color: #9f9f9f;
  text-align: center;
  line-height: 9px;
}

/* .product-descr.new p:first-child {
  font-size: 10px !important;
  font-weight: 600 !important;
  color: #2F2E7C !important;
  text-align: center;
  line-height: 1px ;
 
}
.product-descr.new .p-type{
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #4E4D4D !important;
  text-align: center;
 
  padding-top:5px;
  
}


.product-descr.new .outer-div.footnoter.price{
  font-size: 22px !important;
  font-weight: 800 !important;
  color: #2F2E7C !important;
  text-align: center;
  padding-bottom: 10px;
  
 
}
.product-descr.new .outer-div .price{
  font-size: 22px !important;
  font-weight: 800 !important;
  color: #2F2E7C !important;
  text-align: center;
 
}
.product-descr.new .outer-div span{
  font-size: 14px !important;
  font-weight: 400 !important;
  color:#B1272C !important;
  text-align: center;
 
}
.product-descr.new .footnote{
  font-size: 10px !important;
  font-weight: 500 !important;
  color: #2F2E7C !important;
  text-align: center;
  padding-top:5px;
  padding-bottom: 10px;
  line-height: 5px !important;
  
} */

.product-card .product-footer {
  /* background-color: rgb(208, 224, 232); */
  margin-top: auto;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 333;
}

.cicod-prod-container.new .product-card {
  padding: 5px;
}

.product-card .product-footer a {
  /* color: #21714b; */
  cursor: pointer;
}

.product-card .product-footer a:last-child {
  padding: 5px 30px;
  /* background: #2f2e7c; */
  border-radius: 23px;
  color: #fff;
}

.prod-cont {
  margin-bottom: 30px;
}

.product img {
  /* width: 50px; */
  height: 50px;
}

.product span {
  /* padding-left: 10px; */
  font-size: 12px;
}

.product-card .product span {
  font-size: 14px;
  font-weight: 500;
}

.product-card .product.new {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10%;
}

.enterprise-card .product.new {
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-bottom: 1px solid #e1e1e2; */
}

.enterprise-card .product.newer {
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-bottom: 1px solid #e1e1e2; */
}

.product-card .product.new span {
  font-size: 12px;
  font-weight: 600;
}

.product.new .enterprise-name {
  font-size: 13px;
  text-align: left;
  padding: 2px;
  color: #6a6a6a;
  font-weight: 400;
}

.product-card p:first-child {
  font-size: 18px;
  font-weight: 700;
  padding-bottom: 10px;
}

.sect {
  background-color: #f8f8f8;
  padding-bottom: 40px;
}

.menu {
  display: flex;
  justify-content: space-between;
  padding: 3em 0 0em 0;
}

.bundle-box {
  display: flex;
  flex-direction: column;
  /* width: 48%; */
  background-color: #fff;
  height: 100%;
  /* padding: 10px 0; */
  /* justify-content: space-evenly; */
  align-items: center;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  -moz-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  /* height: 100%; */
}

.menu-item span h3 {
  font-size: 15px;
  font-weight: 600;
  color: #808080;
}

.menu-item span p {
  font-size: 13px;
  font-weight: 100;
  color: #6f6c6c;
  width: 80%;
}

.suite-container {
  /* height: 440px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20%;
}

.product-cta {
  margin-top: -270px;
  margin-right: 50px;
  border-bottom: 1px solid #e1e1e2;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

/* .suite-container .product-cta h1 {
  color: #2f2c7d;
  font-weight: 800;
  font-size: 40px;
  margin-bottom: 2rem;
  line-height: 1.3px;
} */

.product-cta h3:first-child {
  color: #b1272c;
  font-weight: 900;
  padding-bottom: 3px;
}

.product-cta h3:first-child span {
  color: #4e4d4d;
  font-weight: 400;
  padding-bottom: 1px;
  font-size: 20px;
  line-height: 1px;
}

.product-cta h3:nth-child(2) {
  color: #2f2c7d;
  font-weight: 600;
  font-size: 20px;
}

.product-cta h3:nth-child(2) span {
  padding-left: 20px;
  font-size: 15px;
  font-weight: 400;
  color: #b1272c;
}

.product-cta p {
  color: #686868;
  font-size: 1.7rem;
  /* margin-bottom: 3rem; */
}

.product-cta.new p {
  color: #4e4d4d;
  font-size: 2.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.product-cta.new span {
  color: #9f9f9f;
  font-size: 1.7rem;
}

.product-cta.enterprise {
  color: #4e4d4d;
  font-size: 2.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
  margin-top: -10rem;
  width: 80%;
}

.bundle-box img {
  width: 100%;
}

.bundle-box .top,
.bundle-box .description {
  background-color: #fff;
  text-align: center;
  padding: 20px;
}

.bundle-box .description {
  padding: 0 20px;
}

.bundle-box .description .wrapper {
  border-bottom: 1px solid #e0e0e0;
  height: 110px;
  margin-bottom: 1rem;
}

.bundle-box .top h1 {
  font-size: 1.8rem;
  color: #2f2c7d;
  margin: 0;
  font-weight: 600;
}

.bundle-box .description h2 {
  color: #e6821e;
  font-size: 24px;
}

.bundle-box .description h2.map {
  color: rgb(73, 73, 73);
}

.bundle-box .description h2 span {
  font-size: 2rem;
  font-weight: bold;
  color: #21714b;
}

.bundle-box .description h2 span:last-child {
  color: #4e4d4d;
  font-weight: 500;
}

.bundle-box .description p {
  font-size: 1.5rem;
  /* height: 50px; */
}

.bundle-box .description hr {
  /* margin: 0; */
}

.bundle-box .description h2 {
  color: #e6821e;
}

.bundle-box .description.new h2 {
  margin-top: 1rem;
}

.bundle-box .bottom {
  width: 100%;
  padding: 0 20px 20px;
  display: flex;
  justify-content: space-between;
  color: #2f2e7c;
  align-items: center;
}

.bundle-box.first .bottom {
  padding: 10px 19px 1px;
}

.bundle-box .bottom a {
  color: #4e4d4d;
}

.banner--ci {
  display: flex; /* Use flexbox */
  align-items: center; /* Center items vertically */
}

.banner.ci {
  /* Your existing styles */
}

.banner.ci img {
  /* Additional styles for the image */
  margin-right: 20px; /* Adjust as needed */
}

.cta-section {
  margin-top: 6rem;
}

.cta-section .banner {
  background-color: #EFEFEF;
  padding: 30px;
  display: flex;
  border-radius: 24px;
  min-height: 200px;
  height: 180px;
}

.cta-section .banner img {
  width: 70%;
}

/* .cta-section .support.banner img {
    width: 52%;
} */

.cta-section .banner .info h3 {
  font-size: 2.5rem;
  color: #4d4d4d;
  font-weight: 600;
  margin-top: 0;
}
.cta-section .banner .info h4 {
  font-size:24px;
  color: #000000;
  font-weight: 600;
  line-height: normal;
  
}

.cta-section .banner span {
  width: 30%;
}

.cta-section .banner .info {
  width: 90%;
  display: flex;
  flex-direction: column;
}

.cta-section .banner .info p {
  color: #4d4d4d;
  font-size: 1rem;
  height: 45px;
}

.cta-section .ci.banner .info h3 {
  margin-top: 0;
}

.cta-section .banner .info a {
  color: #21714b;
}

.cta-section .banner .info a i {
  margin-left: 1rem;
}

/* product information page */

.cicod-info-box {
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  -moz-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cicod-info-box .product {
  width: 75%;
  margin-bottom: 10px;
}

.cicod-info-box .product span {
  font-size: 20px;
  font-weight: 500;
}

.cicod-info-box .prod p {
  font-size: 15px;
  color: #656565;
}

.cicod-info-box a {
  color: #21714b;
  font-size: 24px;
  font-weight: 500;
  width: 19%;
  cursor: pointer;
}

.cicod-info-box a:hover {
  color: #8d2127;
}

.cicod-info-box .product.map p span {
  color: #21714b !important;
  font-weight: 900 !important;
  font-size: 30px;
}

.cicod-info-box .product.map p {
  font-weight: 500 !important;
  font-size: 30px;
  color: #ffa500;
}

.cicod-info-box a img {
  width: 20%;
}

.nav-tabs > li {
  list-style: none;
}

.cicod-info .nav-tabs {
  border-bottom: none;
  padding: 18px 35px;
  display: flex;
  align-items: center;
}

.cicod-info .nav-tabs > li.active > a,
.cicod-info .nav-tabs > li.active > a:focus,
.cicod-info .nav-tabs > li > a:hover {
  color: #fff;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
  border-bottom-color: transparent;
  cursor: pointer;
}

.cicod-info .nav-tabs > li > a {
  margin-right: 2px;
  line-height: 1.42857143;
  border: none;
  border-radius: 0;
  padding: 7px 29px;
  border-radius: 23px;
  color: #fff;
}

.header img {
  width: 60%;
}

.features ul li {
  color: #b1272d;
  font-size: 18px;
  font-weight: 400;
  /* list-style: square outside none; */
  margin-bottom: 12px;
}

.features ul li span {
  color: #2f2c7d;
  font-weight: 600;
}

.features p {
  font-size: 15px;
  margin-bottom: 25px;
  color: #666666;
}

.features-img img {
  width: 100%;
}

.integration-img {
  width: 85%;
}

/* ucg section */

.value-cont {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.value-cont .value-item {
  width: 300px;
  margin-bottom: 70px;
  position: relative;
  display: flex;
  align-items: start;
  padding-right: 12px;
}

.value-cont .value-item h2 {
  font-size: 16px;
  color: #808080;
  font-weight: 400;
  line-height: 1.5em;
  margin: 0;
}

.value-cont .value-item p {
  color: #2f2c7d;
  font-size: 20px;
  font-weight: 600;
}

.ucg.value-cont .value-item {
  width: 45%;
}

.wfm.value-cont .value-item {
  width: 33%;
}

.wfm.value-cont .value-item img,
.ucg.value-cont .value-item img {
  width: 20%;
  margin-right: 15px;
}

/* //Pricing tab */

/* old style */

/* .price-table {
  margin-bottom: 100px;
  margin-top: 65px;
} */

/* old style */

/* new style */

.price-table {
  margin-bottom: 100px;
  margin-top: 65px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* new style */

.price-header {
  text-align: center;
  border-bottom: 1px solid #eee;
}

.price-body {
  /* border-bottom: 1px solid #eee; */
}

.price-body li {
  margin-bottom: 8px;
  font-size: 12px;
  list-style: none;
}

.price-body li img {
  width: 4%;
  margin-right: 7px;
}

.price-body ul {
  min-height: 350px;
  list-style: none;
}

/* new style */

.price-container {
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  -moz-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  width: 100%;
  margin-bottom: 2em;
  /* display: flex; */
  flex-direction: column;
  border-radius: 20px;
}

/* new style */

.price-container.featured {
  border: 1px solid #000;
  transform: scale(1.1, 1.1);
}

.price-container.featured.ims {
  border-color: #e6821e;
}

.price-container.featured.ucg {
  border-color: #1c1956;
}

.price-container.featured.wfm {
  border-color: #718300;
}

.price-container.featured.com {
  border-color: #7d1615;
}

.price-header,
.price-body {
  padding: 15px 0px;
}

.featured .price-header {
  padding: 0px 0px;
}

.featured .price-header span {
  padding: 3px 15px;
  color: #fff;
}

.price-footer {
  padding: 15px 30px;
  margin-top: auto;
  border-top: 1px solid #dbdadf;
}

.price-footer table {
  width: 100%;
}

.price-footer table td,
.price-footer table th {
  padding-bottom: 10px;
}

.price-footer table th {
  color: #21714b;
}

.price-footer table th:first-child {
  font-weight: 300;
}

.price-footer .actions {
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.price-footer .actions a {
  padding: 8px 35px !important;
}

.merchant.price-body {
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  min-height: 40vh;
}

.merchant.price-body .product span {
  font-size: 12px;
  color: #191363;
  font-size: 1em;
  font-weight: 500;
}

.merchant.price-body .product {
  margin-bottom: 15px;
  position: relative;
}

.merchant.price-body a {
  color: #191363;
}

/* .merchant.price-footer a:first-of-type {
  margin-top: auto;
} */

.feature-links {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 1em;
  flex-direction: column;
}

.merchant.price-body .product:before {
  content: "+";
  position: absolute;
  bottom: -42%;
  left: 55%;
  font-size: 20px;
  color: #af1824;
}

.merchant.price-body .product:last-of-type:before {
  content: "" !important;
}

.merchant .price-container.active,
.merchant .price-container:hover {
  border: 1px solid #af1824;
  cursor: pointer;
}

.merchant .price-footer {
  padding: 10px 20px 10px 20px;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #dbdadf;
}

.merchant .price-footer span {
  margin-top: auto;
}

.merchant .price-footer .footer-inner {
  margin-bottom: auto;
}

/* End product information page */

/* Affiliate Page */

.aff-cont {
  margin-bottom: 20px;
}

.aff-cont-img {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.aff-cont-img img {
  width: 80%;
}

.aff-cont h2 {
  color: #2f2c7d;
  font-size: 26px;
  font-weight: 600;
}

.aff-cont p {
  font-size: 17px;
  font-weight: 400;
  margin-bottom: 24px;
}

.aff-cont a {
  margin-right: 15px;
}

/* End Affiliate Page */

.mobile-prod {
  display: none;
}

/* // subscription page */

/****
******Step form section 
****/

/*custom font*/

/*form styles*/

#msform {
  /* text-align: center; */
  position: relative;
  /* margin: 50px 0; */
}

#msform .step-content {
  background: white;
  border: 0 none;
  border-radius: 0px;
  padding: 10px 0px;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  display: none;
}

#msform .step-content.active {
  display: block;
}

/*Hide all except first .step-content*/

/* #msform .step-content:not(:first-of-type) {
    display: none;
} */

/*headings*/

.step-content h2 {
  padding: 13px;
  background: #dbdee6;
  color: #2d3093;
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  margin-bottom: 15px;
}

/*progressbar*/

#progressbar {
  padding: 0;
  overflow: hidden;
  /*CSS counters to number the steps*/
  /* counter-reset: step; */
}

#progressbar li {
  list-style-type: none;
  color: #959595;
  text-transform: uppercase;
  font-size: 12px;
  width: 30%;
  float: left;
  position: relative;
  padding: 15px;
  background: #eee;
  border: 1px solid #dbdadf;
  height: 50px;
  margin-left: 25px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  line-height: 10px;
}

#progressbar li:first-child {
  margin-left: 0px;
}

#progressbar li.active {
  background: transparent;
  color: #21714b;
  border: 2px solid #21714b;
}

/* #progressbar li:before {
    content: counter(step);
    counter-increment: step;
    width: 24px;
    height: 24px;
    line-height: 26px;
    font-size: 12px;
    color: #333;
    background: white;
    border-radius: 25px;
    margin: 0 auto 10px auto;
} */

#progressbar li span.step {
  background: #fff;
  border-radius: 100%;
  -moz-border-radius: 100%;
  -webkit-border-radius: 100%;
  color: #999999;
  display: inline-block;
  /* font-weight: bold; */
  line-height: 2em;
  margin-right: 10px;
  text-align: center;
  width: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
}

#progressbar li.active span.step {
  background: #21714b;
  color: #fff;
  font-weight: bolder;
}

/*progressbar connectors*/

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: white;
  position: absolute;
  left: -50%;
  top: 9px;
  z-index: -1;
  /*put it behind the numbers*/
}

#progressbar li:first-child:after {
  /*connector not needed before the first step*/
  content: none;
}

/*marking active/completed steps green*/

/*The number of the step and the connector before it = green*/

#progressbar li.active:before,
#progressbar li.active:after {
  background: #ffffff;
  color: #11057d;
  padding: 5px 10px;
}

.mini-inputs {
  display: flex;
}

.mini-inputs span {
  width: 45%;
  margin-right: 10px;
}

.payment-switch {
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 30px;
}

.payment-switch span {
  margin-right: 15px;
  font-weight: 600;
}

.payment-switch span:last-child {
  margin-left: 15px;
}

.payment-action {
  margin-top: 15px;
}

.payment-action p {
  font-size: 1.5em;
  color: #21714b;
}

.payment-action p span {
  font-size: 1em;
  color: #686868;
}

.step-content.map .payment-channel {
  display: flex;
  flex-wrap: wrap;
}

.step-content.map .payment-channel label {
  width: 170px;
  margin-bottom: 10px;
}

.ucg-map table {
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  margin-top: 40px;
}

.ucg-map .table > tbody > tr > td,
.ucg-map .table > thead > tr > th {
  border: none;
  border-right: 1px solid #ddd;
}

.ucg-map .table > thead > tr > th {
  background: #f2f2f2;
  border-bottom: none;
  color: #7f7f7f;
}

.map-charge .radio-cnt {
  display: flex;
}

.map-charge .radio-cnt label {
  width: 45%;
  background-color: #f7f7f7;
  padding: 22px;
  border: 1px #eee solid;
  border-radius: 7px;
}

.map-charge .radio-cnt label.active,
.map-charge .radio-cnt label:hover {
  background-color: #fffafa;
  border-color: #21714b;
}

.map-charge .radio-cnt .checkround {
  top: 23px;
  left: 6px;
}

.step-content .input-group {
  display: flex;
  align-items: center;
}

.step-content .input-group input {
  width: 60%;
  margin-right: 5px;
}

.thankYou {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45vh;
  flex-direction: column;
}

.thankYou h3 {
  /* font-size: 3rem; */
  font-weight: 600;
  font-size: 4rem;
  color: #21714b;
}

.thankYou p {
  font-size: 2rem;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-md {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.solution-sect {
  z-index: 1;
  margin-top: -100px;
}

/* industry section */

.industry-card {
  padding: 10px;
  background-color: #ffffff;
}

.industry-card .img-sect {
  width: 100%;
}

.industry-card .img-sect img {
  width: 100%;
}

.industry-card .title-sect,
.industry-card .text-sect,
.industry-card .link-sect {
  text-align: center;
  padding: 10px 0px;
}

.industry-card .link-sect {
  margin-top: auto;
}

.industry-card .title-sect img {
  width: 10%;
}

.industry-card .title-sect span {
  font-size: 1em;
  padding-left: 10px;
  font-weight: 900;
}

.industry-card .link-sect a {
  border: 1px solid rgba(47, 46, 124, 0.34);
  border-radius: 25px;
  padding: 5px 15px;
  color: #2f2e7c;
  font-weight: bold;
  transition: all 400ms;
  text-decoration: none;
}

.industry-card .link-sect a:hover {
  background-color: #2f2e7c;
  color: #ffffff;
}

.modal-content {
  border-radius: 0px;
}

.modal-header {
  border-bottom: none;
  padding: 0px 10px;
}

.solution-modal__sect {
  display: flex;
  flex-direction: column;
}

.solution-modal__sect .modal__sect__img-sect {
  margin-bottom: 20px;
}

.solution-modal__sect .modal__sect__img-sect img {
  width: 100%;
}

.solution-modal__sect .modal__sect__text-sect img {
  width: 10%;
}

.solution-modal__sect .modal__sect__text-sect span {
  font-size: 18px;
  color: #21714b;
  font-weight: bold;
}

.solution-modal__sect .modal__sect__text-sect p {
  font-size: 12px;
  margin-top: 10px;
}

.load-more-sect {
  border: none;
  background-color: #cecece;
  color: #333333;
  padding: 5px 15px;
  font-weight: 600;
}

/* end industry section */

/* merchant section style */

.mb-2 {
  margin-bottom: 2rem;
}

.merchant-card {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.122);
  margin-bottom: 20px;
  height: 100%;
}

.merchant-card .merchant-card__img-container {
  width: 100%;
  height: 250px;
}

.merchant-card .merchant-card__img-container img {
  width: 100%;
  height: 100%;
}

.merchant-card__descr {
  display: flex;
  padding: 15px 20px;
  flex-direction: column;
}

.merchant-card__descr .img-sect {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.merchant-card__descr .img-sect img {
  width: 20%;
}

.merchant-card__descr .img-sect p {
  font-size: 1.7rem;
  font-weight: 600;
  margin: 0;
}

.merchant-card__descr .text-sect p {
  font-size: 13px;
  margin: 0;
}

.merchant-card__footer {
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.merchant-card__footer p {
  color: #ffffff;
  font-size: 1.5em;
  font-weight: bolder;
  text-transform: capitalize;
  margin: 0;
}

.merchant-card__footer a {
  padding: 5px 30px;
  padding: 5px 30px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 23px;
  color: #ffffff;
  cursor: pointer;
}

/* solution section */

.merchant-sol-sect {
  background-color: #ffffff;
  margin-top: 2em;
  padding-top: 2em;
}

.merchant-sol-sect .intro-text p {
  text-align: center;
  color: #191363;
  font-weight: bolder;
}

.merchant-sol-sect .text-cont {
  display: flex;
  margin-bottom: 1em;
  font-size: 10px;
  height: 50px;
  align-items: center;
  /* background: #000; */
  padding: 0px 10px;
}

.merchant-sol-sect .text-cont p {
  margin: 0;
  line-height: 1.2em;
  font-size: 1.3em;
}

.merchant-sol-sect .text-cont span {
  background-color: #9e0f19;
  color: #ffffff;
  border-radius: 50%;
  padding: 5px 10px;
  font-size: 1.3em;
  font-weight: bolder;
  margin-right: 20px;
}

.merchant-sol-sect .get-started {
  padding: 20px 10px;
  font-size: 10px;
}

.merchant-sol-sect .get-started .text-area {
  text-align: center;
}

.merchant-sol-sect .get-started .text-area p {
  font-size: 1.5em;
  margin-bottom: 1.5em;
}

.merchant-sol-sect .get-started .text-area a {
  font-size: 1.5em;
  background-color: #9e0f19;
  text-decoration: none;
  color: #ffffff;
  border-radius: 25px;
  transition: ease-in-out 200ms;
  padding: 5px 10px;
}

.merchant-sol-sect .get-started .text-area a:hover {
  background-color: #ffffff;
  color: #9e0f19;
  border: 1px solid #9e0f19;
}

.merchant-sol-sect .img-sect {
  display: none;
}

/* start error 404 page style here*/

.error-404-container {
  text-align: center;
  margin-top: 3em;
}

.error-404-container ._head .__title {
  font-weight: bold;
  text-transform: uppercase;
  color: #11057d;
  font-size: 1.5em;
}

.error-404-container ._head .__help-text {
  color: gray;
  font-size: 0.8em;
  margin-bottom: 2em;
}

.error-404-container ._img {
  margin-bottom: 2em;
}

.error-404-container ._img img {
  width: 100%;
}

/* end error 404 page style here*/

/* terms of use page styles */

.terms-service {
  margin-top: 3em;
}

.terms-service .nav li a {
  color: #191363;
}

.terms-service .nav li.active a {
  border: none;
  border-bottom: 5px solid #9e0f19;
  font-weight: bold;
  color: #191363;
}

.terms-service .terms-cont {
  padding-top: 1em;
}

.terms-cont ._intro-title {
  padding: 1em 0;
  color: #646464;
  font-weight: bold;
  font-size: 1.2em;
}

.terms-cont ._intro-title-lite {
  padding: 1em 0;
  color: #646464;
  font-weight: 500;
  font-size: 1.2em;
}

.terms-cont ._intro-title-lite a:hover {
  color: #0c4596;
}

.terms-cont .__list-title {
  font-weight: bold;
  font-size: 1.05em;
  padding: 1em 0;
  color: #191363;
  display: flex;
}

.terms-cont ._list-cont {
  margin-bottom: 2em;
  font-size: 1em;
}

._list-cont .bullet,
._list-cont .main-bullet {
  width: 10%;
}

._list-cont .__bullet-title {
  text-transform: uppercase;
}

._list-cont .__bullet-title,
._list-cont .__list-single {
  width: 90%;
}

.terms-cont .__list_text-cont {
  color: #666666;
  margin-bottom: 0.5em;
  display: flex;
}

.terms-cont .__list_text-cont-sub {
  color: #666666;
  margin-bottom: 0.5em;
  display: flex;
  margin-left: 10%;
}

.terms-cont p.end-of-terms {
  color: #666666;
  font-weight: bold;
  font-size: 1.2em;
  text-transform: uppercase;
}

.terms-cont p.questions {
  color: #666666;
  font-size: 1em;
}

.terms-cont p.questions a {
  color: #656aff;
}

/* end merchant section style */

/* see pricing features styles */

.pricing-feature-main-container .top-title-container {
  display: flex;
  align-items: center;
  padding: 1em 0;
  margin-bottom: 2em;
}

.pricing-feature-main-container .top-title-container > div {
  width: 30%;
}

.pricing-feature-main-container .top-title-container h1 {
  color: #9e0f19;
  /* font-weight: bold;
  font-size: 1.5em; */
  margin-bottom: 20px;
}

.pricing-feature-main-container .tab-wrapper {
}

.pricing-feature-main-container .tab-wrapper .nav-tabs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: none;
  margin-bottom: 2em;
}

.pricing-feature-main-container .tab-wrapper .nav-tabs li a {
  border: 1px solid #dadada;
  padding: 0.5em;
  border-radius: 5px;
  transition: ease-in 200ms;
}

.pricing-feature-main-container .tab-wrapper .nav-tabs li.active a,
.pricing-feature-main-container .tab-wrapper .nav-tabs li a:hover {
  box-shadow: 0px 0px 30px #e7e7e7;
  border: none;
}

.pricing-feature-main-container .tab-wrapper .nav-tabs li a:hover {
  background-color: transparent;
  color: #999999;
}

.pricing-feature-main-container .tab-wrapper .nav-tabs a span {
  color: #808080;
}

.pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-name {
  font-size: 1em;
  text-transform: capitalize;
  font-weight: bold;
}

.pricing-feature-main-container
  .tab-wrapper
  .nav-tabs
  li.active
  a
  span.feature-name {
  color: #c72b33;
}

.pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-charge,
.pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-icon {
  display: none;
}

.pricing-feature-main-container .top-title-container,
.pricing-feature-main-container .tab-wrapper .tab-content .features-info {
  padding-left: 0.5em;
}

.pricing-feature-main-container .tab-wrapper .tab-content .features-info {
  display: flex;
}

.pricing-feature-main-container .features-info .info {
  margin-right: 2em;
}

.pricing-feature-main-container .features-info .info.button-container {
  margin-left: auto;
}

.pricing-feature-main-container .features-info .info p:first-child {
  font-weight: bold;
  color: #2f2c7d;
  font-size: 1.2em;
  line-height: 12px;
}

/* 
 * @Author   Dami seweje
 * @description  Added cicod order id invoice
 * @date   08 Nov, 2019
*/
.cicod-oreder-invoice {
  background: #ffffff;
  display: flex;
  color: #000;
  margin: 10px;
  font-size: 10px;
}

.cicod-oreder-invoice .orderid,
.cicod-oreder-invoice .invoicenow {
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.cicod-oreder-invoice .orderid {
  width: 55%;
}

.cicod-oreder-invoice .orderid .title {
  font-weight: bold;
  color: #4b357d;
  margin-bottom: 0;
  width: 100%;
}

.cicod-oreder-invoice .desc {
  font-size: 1.3em;
  font-weight: 400;
  line-height: 1.5rem;
  color: #585858;
  margin-bottom: 0;
}

.cicod-oreder-invoice .invoicenow {
  width: 47%;
  background: aliceblue;
}

.cicod-oreder-invoice .invoicenow .desc {
  font-weight: bold;
}

.cicod-oreder-invoice .invoicenow p.actions {
  margin-bottom: 0;
  font-size: 1.3em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  margin-top: 1rem;
}

.cicod-oreder-invoice .invoicenow p.actions a.learn-more {
  font-size: 1.3rem;
  margin-right: auto;
}

.cicod-oreder-invoice .invoicenow p.actions a.learn-more:hover {
  color: #004483;
}

.cicod-oreder-invoice .invoicenow p.actions a.cicod-btn {
  font-size: 1.3rem;
  padding: 5px 20px;
}

.hero-inner {
  display: flex;
  align-items: center;
}

.cicod-intro-text {
  width: 45%;
}

.cicod-intro-text.new {
  width: 24%;
}

.cicod-prod-container {
  width: 50%;
}

.cicod-prod-container.new {
  width: 68%;
}

.cicod-prod-container.enterprise {
  width: 62%;
  margin-top: -100px;
}

.cicod-prod-container.enterprise h1 {
  color: #2f2e7c;
  font-size: 26px;
  font-weight: 600;
}

.suggested h1 {
  color: #2f2e7c;
  font-size: 26px;
  font-weight: 600;
  margin-top: -50px;
}

.cicod-prod-container .cicod-prodcard--wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.cicod-prod-container .cicod-prodcard--wrapper.new {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.cicod-prod-container.enterprise .cicod-prodcard--wrapper.enterprise {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
}

.cicod-prodcard--wrapper.enterprise {
  width: 90%;
}

.bundle-software-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
  gap: 3rem;
}

.close {
  font-size: 3rem;
}

.bundle-box .top {
  height: 60px;
  display: flex;
  width: 100%;
  padding: 0;
  align-items: center;
  justify-content: center;
}

/* wed Nov 13 2019 */
.prod-cont-row {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 10rem;
}

.prod-cont-row .products,
.prod-cont-row .bundles {
  padding: 1rem;
  width: 100%;
}

.cta-section--wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.cursor-pointer {
  cursor: pointer;
}

.cicod-bold {
  font-weight: 900 !important;
}

/* payment summary */
.payment-summary {
  background-color: rgba(219, 222, 230, 0.239);
  padding: 2rem 2.5rem;
}

.payment-summary .payment-switch {
  justify-content: flex-end;
  color: #818181;
  text-transform: capitalize;
}

.switch-active {
  color: #21714b;
}

.payment-summary .payment-switch label {
  margin: 0 1rem;
}

.payment-summary .payment-switch span,
.payment-summary .payment-switch span:last-child {
  margin: 0;
}

.price-per-user {
  text-align: right;
  margin-top: 1rem;
  font-size: 1.5rem;
}

.price-per-user p {
  color: #21714b;
  font-weight: bold;
}

.price-per-user p span {
  color: #000000;
  font-weight: normal;
}

.num-of-users,
.total-cost {
  display: flex;
  justify-content: space-between;
  font-size: 1.5rem;
  margin-top: 1rem;
}

.num-of-users p:last-child,
.total-cost p:last-child {
  font-weight: bold;
}

.total-cost p:last-child {
  color: #21714b;
  text-align: right;
}

.payment-summary .payment-action {
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
}

.switchToggle.small-toggle label {
  width: 40px;
  height: 20px;
}

.switchToggle.small-toggle label:after {
  width: 15px;
  height: 15px;
}

.cicod-btn.cicod-btn-sm {
  padding: 6px 12px;
  font-size: 1.2rem;
  font-weight: 500;
}

*[disabled] {
  opacity: 0.6;
  cursor: not-allowed !important;
}

.action-btn--get_started {
  margin-top: 1.54rem;
}

.continue-reg--container {
  text-align: center;
  padding: 3rem 0;
}

.continue-reg--link {
  font-size: 1.7rem;
  font-weight: 600;
  color: #4e4d4d;
}

.continue-reg--link a:hover {
  opacity: 0.8;
  color: rgb(2, 2, 124);
  text-decoration: none;
}

.continue-reg--link i {
  font-size: 1.4rem;
}

/* end  styles */

/* responsive styles */

/*---- MOBILE----*/
@media (max-width: 450px) {
}

@media (max-width: 525px) {
  .cicod-prod-container .cicod-prodcard--wrapper,
  .cicod-prod-container .cicod-prodcard--wrapper.new {
    display: grid;
    grid-template-columns: 1fr;
  }

  .cicod-prod-container {
    width: 90%;
    margin: auto;
  }

  .cicod-oreder-invoice {
    flex-direction: column;
  }

  .cicod-oreder-invoice .orderid,
  .cicod-oreder-invoice .invoicenow {
    width: 100%;
  }

  .suite-container {
  }

  .disable-link {
    pointer-events: none;
    cursor: none;
  }

  .bundle-prod-section {
    margin-top: 65rem;
  }

  .bundle-prod-section.new {
    margin-top: 117rem;
  }

  .suite-container .product-cta h1 {
    font-size: 20px;
  }
}

@media (max-width: 767px) and (min-width: 350px) {
  .suite-container {
    margin-top: -14%;
  }
}

@media (min-width: 526px) and (max-width: 767px) {
  .bundle-prod-section {
    margin-top: 35rem;
  }

  .bundle-prod-section .bundle-box img {
    height: 200px;
  }
}

@media (max-width: 529px) {
  #progressbar {
    display: flex;
  }

  #progressbar li {
    height: 40px;
    padding: 5px;
    margin-left: 10px;
    width: 32%;
    font-size: 11px;
  }

  #progressbar li span.step {
    margin-right: 5px;
  }
}

@media (max-width: 767px) {
  .flex-row {
    flex-direction: column;
  }

  .suite-container {
    /* height: 960px; */
    /* margin-bottom: 45px; */
  }

  .bundle-box {
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
    -moz-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
    box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
    /* margin-bottom: 25px; */
  }

  .suite-container .product-cta {
    margin-top: auto;
  }

  .products {
    /* display: none; */
  }

  .cta-section {
    padding: 0;
  }

  .cta-section .banner {
    padding: 1.5rem 1.5rem 2rem;
  }

  .cta-section .banner .info h3 {
    font-size: 16px;
    height: 35px;
  }

  .cta-section .banner .info p {
    height: 65px;
  }

  .bundle-box .description {
    padding: 15px 18px;
  }

  .bundle-box .top,
  .bundle-box .description {
    padding: 9px;
  }

  .product-card {
    border: 1px solid #ececec;
    -webkit-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
    -moz-box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
    box-shadow: 0px 0px 22px 2px rgba(204, 204, 204, 0.3);
  }

  .mobile-prod .products {
    display: block;
  }

  .menu {
    flex-direction: column;
    padding: 0em 10px 0em 10px;
  }

  .hero h2 {
    font-size: 14px;
    font-weight: 400;
  }

  .hero h1 {
    font-size: 29px;
    font-weight: 500;
  }

  .menu-item {
    display: flex;
    width: 100%;
    background-color: #fff;
    height: 110px;
    padding: 45px 0 45px 0;
    justify-content: space-evenly;
    align-items: center;
    border-radius: 10px;
    margin-bottom: 25px;
  }

  .menu-item img {
    height: 55px;
    margin-right: 15px;
    margin-left: 15px;
  }

  .menu-item span h3 {
    font-size: 14px;
    font-weight: 600;
  }

  .menu-item span p {
    font-size: 11px;
    font-weight: 400;
    color: #646464;
  }

  .sect {
    background-color: #f8f8f8;
    padding-bottom: 40px;
    padding-top: 25px;
  }

  .jumbotron {
    padding-top: 2em;
    margin-bottom: -30px;
    height: 330px;
  }

  .hero h1 {
    font-size: 45px;
    font-weight: 800;
  }

  .hero p {
    font-size: 17px;
    margin-top: 20px;
  }

  .navbar-toggle .icon-bar {
    background-color: #be151d;
  }

  .mobile-prod,
  .mobile-prod .prod-cont {
    display: block;
  }

  .product {
    display: flex;
    width: 60%;
    align-items: center;
  }

  .mobile-prod h2 small {
    color: #be151d;
    cursor: pointer;
  }

  .mobile-prod h2 small:hover {
    color: #c72b33;
  }

  #footer {
    padding: 1em;
    margin-top: 50px;
  }

  #footer .navbar-brand {
    margin-bottom: 30px;
  }

  .cicod-info-box {
    flex-direction: column;
    margin-top: 50px;
    padding: 16px 15px;
  }

  .cicod-info-box .product {
    width: 100%;
  }

  .cicod-info-box .product span {
    font-size: 17px;
    font-weight: 500;
  }

  .cicod-info-box a {
    font-size: 20px;
    width: 100%;
  }

  .cicod-info-box a img {
    width: 9%;
  }

  .price-container.featured {
    transform: none;
  }

  .price-container {
    margin: 20px auto;
  }

  .cicod-btn {
    padding: 8px 20px;
    font-size: 13px;
  }

  .price-footer .actions a {
    padding: 8px 25px !important;
  }

  .cicod-info .nav-tabs {
    padding: 14px 4px;
    flex-wrap: wrap;
  }

  .cicod-info .nav-tabs > li > a {
    line-height: 2.4;
  }

  .main-content .top h2 {
    padding: 1em;
    font-size: 13px;
    line-height: 1.7em;
  }

  .header img {
    width: 100%;
  }

  .centered-flex {
    flex-direction: column;
  }

  .centered-flex:nth-of-type(even) {
    flex-direction: column-reverse;
  }

  /* ############################################################# */

  /* ############################################################# */
}

/*---- TABLET ----*/

@media (min-width: 768px) and (max-width: 991px) {
  .bundle-prod-section {
    margin-top: 14rem;
  }

  .bundle-prod-section .prod-cont-row .bundles {
    width: 100%;
  }
}

@media (max-width: 991px) {
  .hero-inner {
    flex-direction: column;
  }

  .jumbotron {
    flex-direction: column;
  }

  .cicod-intro-text,
  .cicod-intro-text.new,
  .cicod-prod-container,
  .cicod-prod-container.new {
    width: 100%;
  }

  .cicod-oreder-invoice {
    -webkit-box-shadow: 0px 0px 8px 0px rgba(227, 227, 227, 1);
    -moz-box-shadow: 0px 0px 8px 0px rgba(227, 227, 227, 1);
    box-shadow: 0px 0px 8px 0px rgba(227, 227, 227, 1);
  }

  .cicod-oreder-invoice p {
    margin: 0;
  }

  .hero p img {
    width: 5%;
  }

  .cta-section--wrapper {
    grid-template-columns: 1fr;
  }

  .wfm.value-cont {
    flex-direction: column;
  }

  .wfm.value-cont .value-item {
    width: 100%;
  }

  /* .homepage-hero .form-container {
    width: 60%;
  } */
}

@media only screen and (min-width: 768px) {
  .bundle-box img {
    /* height: 160px; */
  }

  .industry-jumbotron {
    height: 300px;
  }

  .industry-card .title-sect span {
    font-size: 2em;
    padding-left: 10px;
    font-weight: 900;
  }

  .industry-card .text-sect p {
    font-size: 1.5em;
  }

  .industry-card .link-sect a {
    padding: 8px 15px;
  }

  .solution-modal__sect .modal__sect__text-sect p {
    font-size: 14px;
  }

  .merchant-card__descr .text-sect p {
    font-size: 20px;
  }

  .merchant-card__descr .img-sect p {
    font-size: 24px;
  }

  .merchant-card__footer a {
    padding: 10px 30px;
  }

  .price-table {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2em;
  }

  .merchant .price-footer span {
    margin-top: 0;
  }

  /* 
  .price-container {
    width: 100%;
  } */
  /* see-pricing features */
  .pricing-feature-main-container .tab-wrapper .tab-content .features-info {
    padding-left: 0.5em;
  }

  .pricing-feature-main-container .top-title-container > div {
    width: 50%;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs li {
    width: 23%;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs li a {
    padding: 1.5em;
  }

  .pricing-feature-main-container .top-title-container,
  .pricing-feature-main-container .tab-wrapper .tab-content .features-info {
    padding-left: 1em;
  }
}

@media only screen and (min-width: 1048px) {
  .prod-cont-row {
    flex-direction: row;
    justify-content: space-between;
  }

  .prod-cont-row .products {
    width: 35%;
  }

  .prod-cont-row .bundles {
    width: 75%;
  }

  .bundle-box .description .wrapper {
    height: 130px;
  }

  .bundle-box .description.new .wrapper {
    height: 110px;
  }

  .bundle-box .top h1 {
    font-size: 1.5rem;
  }

  .bundle-box .top {
    padding: 1rem;
  }

  .industry-card .title-sect {
    height: 20px;
    margin-bottom: 20px;
  }

  .industry-card .text-sect {
    height: 60px;
    margin-bottom: 20px;
  }

  .industry-card .title-sect span {
    font-size: 13px;
    padding-left: 10px;
    font-weight: bold;
  }

  .industry-card .text-sect p {
    font-size: 13px;
  }

  .industry-card .link-sect a {
    padding: 5px 15px;
  }

  .solution-modal__sect .modal__sect__text-sect p {
    font-size: 14px;
  }

  .solution-modal__sect {
    display: flex;
    flex-direction: row;
  }

  .solution-modal__sect .modal__sect__img-sect {
    width: 40%;
    margin-bottom: 10px;
  }

  .solution-modal__sect .modal__sect__text-sect {
    width: 60%;
    padding-left: 20px;
  }

  .pr-lg-2 {
    padding-right: 2.5rem;
  }

  .pl-lg-2 {
    padding-left: 2.5rem;
  }

  .merchant-card__descr {
    flex-direction: row;
    height: 110px;
  }

  .merchant-card__descr .text-sect {
    width: 60%;
  }

  .merchant-card__descr .text-sect p {
    font-size: 12px;
  }

  .merchant-card__descr .img-sect {
    width: 40%;
  }

  .merchant-card__descr .img-sect img {
    width: 30%;
  }

  .merchant-card__descr .img-sect p {
    font-size: 15px;
  }

  .merchant-card__footer a {
    padding: 5px 30px;
  }

  .merchant-card__footer a {
    padding: 10px 30px;
  }

  .merchant-sol-sect .sol-list {
    display: flex;
    /* background: #000; */
    flex-direction: row;
  }

  .merchant-sol-sect .sol-list .cont-one,
  .merchant-sol-sect .sol-list .cont-two {
    width: 50%;
  }

  .merchant-sol-sect .intro-text p,
  .merchant-sol-sect .get-started .text-area p,
  .merchant-sol-sect .get-started .text-area a {
    font-size: 1.3em;
  }

  .merchant-sol-sect .get-started {
    padding: 40px 20px;
    font-size: 10px;
  }

  .merchant-sol-sect .get-started .text-area {
    text-align: left;
  }

  .industry-card .title-sect span {
    font-size: 13px;
    padding-left: 10px;
    font-weight: bold;
  }

  .industry-card .text-sect p {
    font-size: 13px;
  }

  .industry-card .link-sect a {
    padding: 5px 15px;
  }

  .solution-modal__sect .modal__sect__text-sect p {
    font-size: 14px;
  }

  .solution-modal__sect {
    display: flex;
    flex-direction: row;
  }

  .solution-modal__sect .modal__sect__img-sect {
    width: 40%;
    margin-bottom: 10px;
  }

  .solution-modal__sect .modal__sect__text-sect {
    width: 60%;
    padding-left: 20px;
  }

  .pr-lg-2 {
    padding-right: 2.5rem;
  }

  .pl-lg-2 {
    padding-left: 2.5rem;
  }

  .merchant-card__descr {
    flex-direction: row;
    height: 110px;
  }

  .merchant-card__descr .text-sect {
    width: 60%;
  }

  .merchant-card__descr .text-sect p {
    font-size: 12px;
  }

  .merchant-card__descr .img-sect {
    width: 40%;
  }

  .merchant-card__descr .img-sect img {
    width: 30%;
  }

  .merchant-card__descr .img-sect p {
    font-size: 15px;
  }

  .merchant-card__footer a {
    padding: 5px 30px;
  }

  .merchant-sol-sect {
    position: relative;
  }

  .merchant-sol-sect .sol-list,
  .merchant-sol-sect .intro-text {
    width: 60%;
  }

  .solution-modal__sect .modal__sect__text-sect {
    width: 60%;
    padding-left: 20px;
  }

  .pr-lg-2 {
    padding-right: 2.5rem;
  }

  .pl-lg-2 {
    padding-left: 2.5rem !important;
  }

  .merchant-card__descr {
    flex-direction: row;
    height: 110px;
  }

  .merchant-card__descr .text-sect {
    width: 60%;
  }

  .merchant-card__descr .text-sect p {
    font-size: 12px;
  }

  .merchant-card__descr .img-sect {
    width: 40%;
  }

  .merchant-card__descr .img-sect img {
    width: 30%;
  }

  .merchant-card__descr .img-sect p {
    font-size: 15px;
  }

  .merchant-card__footer a {
    padding: 5px 30px;
  }

  .merchant-card__footer a {
    padding: 10px 30px;
  }

  .merchant-sol-sect .sol-list {
    display: flex;
    /* background: #000; */
    flex-direction: row;
  }

  .merchant-sol-sect .sol-list .cont-one,
  .merchant-sol-sect .sol-list .cont-two {
    width: 50%;
  }

  .merchant-sol-sect .intro-text p,
  .merchant-sol-sect .get-started .text-area p,
  .merchant-sol-sect .get-started .text-area a {
    font-size: 1.3em;
  }

  .merchant-sol-sect .get-started {
    padding: 40px 20px;
    font-size: 10px;
  }

  .merchant-sol-sect .get-started .text-area {
    text-align: left;
  }

  .industry-card .title-sect span {
    font-size: 13px;
    padding-left: 10px;
    font-weight: bold;
  }

  .industry-card .text-sect p {
    font-size: 13px;
  }

  .industry-card .link-sect a {
    padding: 5px 15px;
  }

  .solution-modal__sect .modal__sect__text-sect p {
    font-size: 14px;
  }

  .solution-modal__sect {
    display: flex;
    flex-direction: row;
  }

  .solution-modal__sect .modal__sect__img-sect {
    width: 40%;
    margin-bottom: 10px;
  }

  .solution-modal__sect .modal__sect__text-sect {
    width: 60%;
    padding-left: 20px;
  }

  .pr-lg-2 {
    padding-right: 2.5rem;
  }

  .pl-lg-2 {
    padding-left: 2.5rem !important;
  }

  .merchant-card__descr {
    flex-direction: row;
    height: 110px;
  }

  .merchant-card__descr .text-sect {
    width: 60%;
  }

  .merchant-card__descr .text-sect p {
    font-size: 12px;
  }

  .merchant-card__descr .img-sect {
    width: 40%;
  }

  .merchant-card__descr .img-sect img {
    width: 30%;
  }

  .merchant-card__descr .img-sect p {
    font-size: 15px;
  }

  .merchant-card__footer a {
    padding: 5px 30px;
  }

  .merchant-sol-sect {
    position: relative;
  }

  .merchant-sol-sect .img-sect {
    position: absolute;
    width: 50%;
    right: 0;
    z-index: 2;
    bottom: 20%;
    height: 80%;
    overflow: hidden;
    display: block;
  }

  .merchant-sol-sect .img-sect img {
    width: 160%;
    height: 100%;
  }

  .merchant-sol-sect .sol-list,
  .merchant-sol-sect .intro-text {
    width: 60%;
  }

  .merchant-sol-sect .intro-text p {
    text-align: left;
    font-size: 1.5em;
  }

  .merchant-sol-sect .intro-text {
    padding-top: 20px;
  }

  .merchant-sol-sect .text-cont p {
    font-size: 1.4em;
  }

  .merchant-sol-sect .get-started {
    padding-top: 100px;
    padding-bottom: 50px;
  }

  .merchant-sol-sect .get-started .text-area {
    text-align: left;
  }

  .merchant-sol-sect .get-started .text-area p {
    font-size: 1.6em;
  }
}

@media only screen and (min-width: 992px) {
  .industry-card .title-sect {
    height: 20px;
    margin-bottom: 20px;
  }

  .industry-card .text-sect {
    height: 60px;
    margin-bottom: 20px;
  }

  .industry-card .title-sect span {
    font-size: 13px;
    padding-left: 10px;
    font-weight: bold;
  }

  .industry-card .text-sect p {
    font-size: 13px;
  }

  .industry-card .link-sect a {
    padding: 5px 15px;
  }

  .solution-modal__sect .modal__sect__text-sect p {
    font-size: 14px;
  }

  .solution-modal__sect {
    display: flex;
    flex-direction: row;
  }

  .solution-modal__sect .modal__sect__img-sect {
    width: 40%;
    margin-bottom: 10px;
  }

  .solution-modal__sect .modal__sect__text-sect {
    width: 60%;
    padding-left: 20px;
  }

  .pr-lg-2 {
    padding-right: 2.5rem;
  }

  .pl-lg-2 {
    padding-left: 2.5rem;
  }

  .merchant-card__descr {
    flex-direction: row;
    height: 110px;
  }

  .merchant-card__descr .text-sect {
    width: 60%;
  }

  .merchant-card__descr .text-sect p {
    font-size: 12px;
  }

  .merchant-card__descr .img-sect {
    width: 40%;
  }

  .merchant-card__descr .img-sect img {
    width: 30%;
  }

  .merchant-card__descr .img-sect p {
    font-size: 15px;
  }

  .merchant-card__footer a {
    padding: 5px 30px;
  }

  .merchant-sol-sect {
    position: relative;
  }

  .merchant-sol-sect .img-sect {
    background: url("/static/img/products/CMB1.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: left;
    position: absolute;
    width: 45%;
    right: 0;
    z-index: 2;
    bottom: 25%;
    height: 70%;
    overflow: hidden;
    display: block;
  }

  .merchant-sol-sect .sol-list,
  .merchant-sol-sect .intro-text {
    width: 60%;
  }

  .merchant-sol-sect .intro-text p {
    text-align: left;
    font-size: 1.5em;
  }

  .merchant-sol-sect .intro-text {
    padding-top: 20px;
  }

  .merchant-sol-sect .text-cont p {
    font-size: 1.4em;
  }

  .merchant-sol-sect .get-started {
    padding-top: 100px;
  }

  .merchant-sol-sect .get-started .text-area {
    text-align: left;
  }

  .merchant-sol-sect .get-started .text-area p {
    font-size: 1.6em;
  }

  .merchant-sol-sect .get-started .text-area a {
    font-size: 1.5em;
    padding: 8px 13px;
  }

  .merchant-sol-sect .img-sect img {
    width: 160%;
    height: 100%;
  }

  .merchant-sol-sect .sol-list,
  .merchant-sol-sect .intro-text {
    width: 60%;
  }

  .merchant-sol-sect .intro-text p {
    text-align: left;
    font-size: 1.5em;
  }

  .merchant-sol-sect .intro-text {
    padding-top: 20px;
  }

  .merchant-sol-sect .text-cont p {
    font-size: 1.4em;
  }

  .merchant-sol-sect .get-started {
    padding-top: 100px;
  }

  .merchant-sol-sect .get-started .text-area {
    text-align: left;
  }

  .merchant-sol-sect .get-started .text-area p {
    font-size: 1.6em;
  }

  .merchant-sol-sect .get-started .text-area a {
    font-size: 1.5em;
    padding: 8px 13px;
  }

  /* error page */
  .error-404-container {
    margin-top: 0;
  }

  .error-404-container ._head .__title {
    font-size: 2em;
  }

  .error-404-container ._head .__help-text {
    font-size: 1em;
  }

  .error-404-container ._img img {
    width: 70%;
  }

  /* terms of use page styles */
  .terms-service {
    margin-top: 0;
  }

  .terms-service .terms-cont {
    padding-top: 3em;
  }

  .terms-cont ._intro-title {
    font-size: 1.5em;
  }

  .terms-cont .__list-title {
    font-size: 1.1em;
  }

  .terms-cont ._list-cont {
    font-size: 1.3em;
  }

  ._list-cont .bullet,
  ._list-cont .main-bullet {
    padding: 0.2em;
  }

  .terms-cont p.end-of-terms {
    font-size: 2em;
  }

  .terms-cont p.questions {
    font-size: 1.5em;
  }

  /* end terms of use styles here */
  /* prcing table fix */
  .price-table {
    display: flex;
    flex-direction: row;
    justify-content: left;
  }

  /* .price-container {
    width: 30%;
  } */
  .merchant .price-footer {
    min-height: 20vh;
  }

  .merchant .price-footer span {
    margin-top: auto;
  }

  /* see pricing features */
  .pricing-feature-main-container .top-title-container > div {
    width: 50%;
  }

  .pricing-feature-main-container .tab-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs {
    width: 30%;
    flex-direction: column;
    margin-bottom: 0;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs li {
    margin-bottom: 3em;
    width: 100%;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-charge,
  .pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-icon {
    display: block;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs li a {
    padding: 1em 2em;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs a span {
    padding: 0.1em 0;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-name {
    font-size: 1.8em;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-charge {
    font-size: 1.5em;
  }

  .pricing-feature-main-container .tab-wrapper .nav-tabs a span.feature-icon {
    display: flex;
  }

  .pricing-feature-main-container
    .tab-wrapper
    .nav-tabs
    a
    span.feature-icon
    img {
    width: 10%;
  }

  .pricing-feature-main-container .tab-wrapper .tab-content {
    width: 65%;
  }

  .pricing-feature-main-container .top-title-container,
  .pricing-feature-main-container .tab-wrapper .tab-content .features-info {
    padding-left: 0;
  }

  .pricing-feature-main-container .features-info .info p:first-child {
    font-weight: bold;
    color: #2f2c7d;
    font-size: 1.5em;
  }
}

@media only screen and (min-width: 526px) and (max-width: 991px) {
  .cta-section .banner {
    background-color: #EFEFEF;
    padding: 30px;
    display: flex;
    border-radius: 24px;
    min-height: 200px;
    height: auto;
  }
  .hero-inner {
    margin-top: 9rem;
  }
}

@media only screen and (min-width: 2000px) {
  .cta-section .banner {
    background-color: #EFEFEF;
    padding: 30px;
    display: flex;
    border-radius: 24px;
    min-height: 200px;
    height: auto;
  }
  .merchant-sol-sect .img-sect {
    background-size: contain;
  }
}

@media (max-width: 767px) {
  .merchant-card .merchant-card__img-container {
    height: 100%;
  }

  .pricing-feature-main-container .tab-wrapper .tab-content .features-info {
    flex-direction: column;
  }

  .pricing-feature-main-container .features-info .info {
    margin-right: 2rem;
    margin-bottom: 2rem;
  }

  .continue-reg--link a {
    display: block;
  }
}

/* ----------------------------------------------
 * Generated by Lanre Yusuf on 2020-6-19 13:25:4
 * 
 * 
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-left
 * ----------------------------------------
 */

.fade-in {
  /* -webkit-animation: slide-left 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1s both;
          animation: slide-left 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1s both; */

  animation: fadein 2s;
  -moz-animation: fadein 2s;
  /* Firefox */
  -webkit-animation: fadein 2s;
  /* Safari and Chrome */
  -o-animation: fadein 2s;
  /* Opera */
}

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadein {
  /* Firefox */
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes fadein {
  /* Safari and Chrome */
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-o-keyframes fadein {
  /* Opera */
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes slide-left {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }

  100% {
    -webkit-transform: translateX(-100px);
    transform: translateX(-100px);
  }
}

@keyframes slide-left {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }

  100% {
    -webkit-transform: translateX(-100px);
    transform: translateX(-100px);
  }
}  
`